<template>
  <!-- prevent: dentro del <label> de una opción no marca el radio -->
  <a
    class="nkr-code-link"
    :title="`Ver ${code}`"
    @click.prevent.stop="openProduct(code)"
    >{{ code }}</a
  >
</template>

<script>
// Un código NKR que abre el modal del producto (lo pone AssistantBubble)
export default {
  name: "NkrCodeLink",
  inject: ["openProduct"],
  props: {
    code: { type: String, required: true }
  }
};
</script>

<style lang="scss" scoped>
.nkr-code-link {
  color: #2563eb;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
  &:hover {
    text-decoration-style: solid;
  }
}
</style>
